import type { CityConfig } from "@/pages/city-template/types";

export const hydeParkConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hyde Park",
  state: "New York",
  stateAbbr: "NY",
  slug: "hyde-park",
  route: "/cities/hyde-park",
  title: "Emergency Passport Hyde Park, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Hyde Park, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Hyde Park, FDR Presidential Library, Culinary Institute of America, SWF/ALB/JFK travelers, and all Dutchess County communities.",
  h1: "Emergency & Expedited Passport Services in Hyde Park, NY",
  heroSubtitle: "Culinary Institute of America student staging at a Michelin-starred kitchen in Lyon next month? FDR Presidential Library historian presenting at a conference in London in 10 days? Hudson Valley family booking a last-minute European river cruise? We help Hyde Park residents — from CIA chefs-in-training to FDR estate historians to Staatsburg families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20the%20Franklin%20D%20Roosevelt%20Presidential%20Library%20and%20Museum%20in%20Hyde%20Park%20New%20York%20with%20the%20historic%20Springwood%20estate%20overlooking%20the%20Hudson%20River%2C%20rolling%20Dutchess%20County%20countryside%20with%20autumn%20foliage%20in%20rich%20gold%20and%20orange%2C%20Culinary%20Institute%20of%20America%20campus%20with%20its%20distinctive%20architecture%2C%20Hudson%20River%20Valley%20landscape%20with%20distant%20Catskill%20Mountains%20at%20golden%20hour%2C%20warm%20editorial%20travel%20photography%20with%20rich%20tones%2C%20no%20text%20overlay%2C%20clean%20professional%20composition%20highlighting%20American%20history%20and%20natural%20beauty&width=1600&height=700&seq=hyde-park-hero-v3-001&orientation=landscape",
  heroImageAlt: "Hyde Park New York with FDR Presidential Library and Hudson River Valley at golden hour",
  geoPosition: "41.7948;-73.9338",
  geoPlacename: "Hyde Park, New York",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~85 miles south in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Hyde Park", zips: "12538" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Poughkeepsie", zips: "12601, 12602, 12603, 12604" },
    { name: "Wappingers Falls", zips: "12590" },
    { name: "Staatsburg", zips: "12580" },
    { name: "Red Hook", zips: "12571" },
    { name: "Tivoli", zips: "12583" },
    { name: "Millbrook", zips: "12545" },
    { name: "Amenia", zips: "12501" },
    { name: "Pleasant Valley", zips: "12569" },
    { name: "Clinton Corners", zips: "12514" },
    { name: "Kingston", zips: "12401, 12402, 12411, 12429, 12432, 12441, 12449, 12484, 12485, 12487, 12490, 12491, 12492, 12496" },
    { name: "Newburgh", zips: "12550" },
    { name: "Beacon", zips: "12508" },
    { name: "Fishkill", zips: "12524" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing for Dutchess County", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Hyde Park-area travelers with immediate departures from SWF, ALB, or JFK." },
    { icon: "ri-restaurant-line", title: "Culinary Institute of America Expertise", desc: "The world's premier culinary college sends students to stage at Michelin-starred kitchens across Europe and Asia. We know the externship acceptance-to-departure timeline cold." },
    { icon: "ri-building-2-line", title: "FDR Presidential Library & Historian Travel", desc: "FDR historians, National Park Service staff, and presidential scholars travel internationally for conferences, research exchanges, and diplomatic history events." },
    { icon: "ri-landscape-line", title: "Hudson River Estate Country", desc: "From the Vanderbilt Mansion to the Mills Mansion, from Staatsburg to Rhinebeck — Hyde Park anchors the Hudson River's historic estate corridor with a globally connected community." },
  ],
  internalLinks: [
    { name: "Fast passport services in Poughkeepsie, NY", route: "/cities/poughkeepsie" },
    { name: "Expedited passport in Rhinebeck, NY", route: "/cities/rhinebeck" },
    { name: "Quick passport services in Kingston, NY", route: "/cities/kingston" },
    { name: "Urgent passport services in Newburgh, NY", route: "/cities/newburgh" },
    { name: "New York passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Hyde Park and all of Dutchess County via secure registered courier with direct access to the New York Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Hyde Park residents can ship from any UPS Store, FedEx Office, or post office location across the Hudson Valley.",
  fpcOfficeDistance: "Serving Hyde Park, Staatsburg, Rhinebeck, Poughkeepsie, and all Dutchess County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Hyde Park and the greater Hudson Valley. From the FDR Presidential Library and the Culinary Institute of America to the historic estates along the Hudson River, from Staatsburg to Rhinebeck — we serve all of Dutchess County. Our courier service eliminates the need to drive 85 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Hyde Park and all Dutchess County communities including Staatsburg, Rhinebeck, Poughkeepsie, Wappingers Falls, Red Hook, Millbrook, and Pleasant Valley. We also serve CIA students and faculty, FDR historians, and Hudson Valley travelers departing from SWF, ALB, and JFK.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Hyde Park as simple as possible — with the speed CIA students heading to European kitchens, FDR historians traveling for research, and Dutchess County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Hyde Park travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Hyde Park travelers encounter unique passport issues — everything from CIA externship acceptance windows to FDR research travel with short conference notice. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Hyde Park travelers — from CIA student chefs to FDR Presidential Library historians to Staatsburg families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Hyde Park, NY? Here are the most common ones we hear from Dutchess County and Hudson Valley travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you're a CIA student heading to a Michelin-starred stage in Lyon, an FDR historian presenting at an international conference, or a Dutchess County family planning a European river cruise — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "CIA externship acceptance in Lyon — departure in 5 days? Family emergency abroad requiring immediate travel? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Hyde Park-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Hyde Park residents renew fast — no agency visit required for most renewals. Perfect for CIA faculty, FDR historians, and Dutchess County professionals.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Hyde Park residents — from CIA students to Staatsburg families — through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Hudson Valley travel or CIA externship is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Dutchess County family vacation or first international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports. Common for Hyde Park residents and CIA faculty after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for CIA chef-instructors with overlapping European stages and FDR historians with back-to-back international conferences.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Kitchen grease, sauce splatters, and water damage from Hudson River activities — damaged passports happen. We guide Hyde Park travelers through replacement faster than you think.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Convenient for Hudson Valley travelers heading to Montreal or Quebec.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hyde Park NY", description: "Urgent passport processing for Hyde Park NY travelers, CIA students, and FDR historians with immediate departure needs." },
    { name: "Expedited Passport Renewal Hyde Park NY", description: "Fast passport renewal for Hyde Park NY residents with a previously-issued passport." },
    { name: "First-Time Passport Hyde Park NY", description: "New passport application services for Hyde Park NY residents and CIA students applying for their first passport." },
    { name: "Child Passport Hyde Park NY", description: "Minor passport services for Hyde Park NY families with children under 16." },
    { name: "Name Change Passport Hyde Park NY", description: "Passport name correction after marriage, divorce, or legal name changes for Hyde Park residents." },
    { name: "Second Passport Hyde Park NY", description: "Second passport services for Hyde Park CIA faculty and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Amanda S.",
      location: "Culinary Institute of America, Hyde Park",
      rating: 5,
      text: "Got accepted to stage at a three-Michelin-star kitchen in Lyon — departure in 4 weeks. Needed my first passport. Fast Passport Center guided me through the whole process and had it back in 5 days. The CIA Career Services office now recommends them to all students heading to Europe.",
      service: "New Passport",
    },
    {
      name: "Dr. Robert K.",
      location: "FDR Presidential Library, Hyde Park",
      rating: 5,
      text: "Was invited to present at a diplomatic history conference at Oxford with 10 days notice. My passport had expired during COVID. Fast Passport Center renewed it in 48 hours. Made the conference, chaired my panel, and the FDR Library research exchange was saved.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "The Benson Family",
      location: "Staatsburg, NY",
      rating: 5,
      text: "Booked a European river cruise for our 25th anniversary — realized both passports were expired with 3 weeks to go. Fast Passport Center handled both renewals simultaneously. Arrived in 5 days. The Mills Mansion neighborhood recommends them to everyone planning international travel.",
      service: "Passport Renewal",
    },
    {
      name: "Chef Elena R.",
      location: "CIA Faculty, Hyde Park",
      rating: 5,
      text: "As a CIA chef-instructor, I travel to Europe twice a year for culinary research. Fast Passport Center expedited my name change passport after I got married — 4 days from Hyde Park to my door. Essential service for culinary professionals with fixed research schedules.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "hyde-park-1",
      name: "Hyde Park Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "424 Albany Post Road",
      city: "Hyde Park",
      state: "NY",
      zip: "12538",
      phone: "(845) 229-8074",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Downtown Hyde Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Hyde Park passport acceptance facility. Walking distance from the FDR Presidential Library. Extremely busy during CIA semester transitions — book 3+ weeks ahead during peak student travel periods.",
      icon: "ri-mail-line",
    },
    {
      id: "hyde-park-2",
      name: "Poughkeepsie Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "55 Mansion Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "(845) 471-5220",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Poughkeepsie — south of Hyde Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Major Dutchess County passport acceptance facility. Passport photos available on-site. More appointment slots than Hyde Park — good alternative during CIA externship season.",
      icon: "ri-mail-line",
    },
    {
      id: "hyde-park-3",
      name: "Rhinebeck Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6387 Mill Street",
      city: "Rhinebeck",
      state: "NY",
      zip: "12572",
      phone: "(845) 876-4031",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rhinebeck — north of Hyde Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for northern Hyde Park, Staatsburg, and Rhinebeck residents. Less crowded alternative when Hyde Park post office is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "hyde-park-4",
      name: "Dutchess County Clerk — Passport Acceptance",
      type: "County Clerk Passport Acceptance",
      address: "22 Market Street",
      city: "Poughkeepsie",
      state: "NY",
      zip: "12601",
      phone: "(845) 486-2120",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Poughkeepsie — Dutchess County Office Building",
      website: "https://www.dutchessny.gov/Departments/County-Clerk/Passports.htm",
      websiteLabel: "Dutchess County Clerk",
      notes: "County clerk passport acceptance — excellent for first-time applicants. No passport photos on-site. Convenient for Hyde Park residents who prefer county office service.",
      icon: "ri-government-line",
    },
    {
      id: "hyde-park-5",
      name: "Wappingers Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "779 Route 9",
      city: "Wappingers Falls",
      state: "NY",
      zip: "12590",
      phone: "(845) 297-4334",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Wappingers Falls — south of Hyde Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves southern Dutchess County. Convenient backup when Hyde Park and Poughkeepsie facilities are fully booked. Less crowded — good for last-minute appointments.",
      icon: "ri-mail-line",
    },
    {
      id: "hyde-park-6",
      name: "Culinary Institute of America — Career Services",
      type: "Campus Passport Resource",
      address: "1946 Campus Drive",
      city: "Hyde Park",
      state: "NY",
      zip: "12538",
      phone: "(845) 451-1006",
      hours: "Academic year: Mon–Fri 8:30 AM – 5:00 PM",
      distance: "CIA Campus — Hyde Park",
      website: "https://www.ciachef.edu/career-services/",
      websiteLabel: "CIA Career Services",
      notes: "CIA Career Services provides externship placement guidance and can connect students with passport resources. Students should coordinate with Career Services and Fast Passport Center for expedited processing before international stages.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 85 miles to Manhattan Passport Agency", fpc: "Most Hyde Park travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays — critical for first-time CIA student applicants" },
    { feature: "CIA Externship Timing", agency: "No accommodation for culinary school externship windows", fpc: "We know the CIA acceptance-to-stage timeline and coordinate around externship start dates" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Hudson Valley-Specific Guidance", agency: "Generic — no CIA, FDR Library, or Dutchess County expertise", fpc: "Full CIA/FDR Library/SWF-ALB-JFK/Dutchess County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "CIA Student Waiting Until Externship Acceptance to Start",
      description: "Culinary Institute students often wait until they receive their formal externship placement before starting passport paperwork — leaving only 3–6 weeks. Start your passport application the moment you apply for an international stage.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Kitchen-Damaged Passports from Culinary Work",
      description: "CIA students working in teaching kitchens frequently damage passports with grease, water, flour, and sauce splatters. A passport with any stains or water damage is invalid. Keep your passport in a sealed plastic bag far from kitchen workstations.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "First-time applicants — the majority of CIA students heading abroad — must use DS-11 and visit an acceptance facility. Attempting the simpler DS-82 renewal form will result in rejection and lost time during the tight externship window.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards for Academic/Professional Use",
      description: "Passport photos for CIA students and FDR historians require strict compliance — these professionals are scrutinized at international borders. Drugstore photos often fail. We verify every photo before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Visa Processing After Passport Arrival",
      description: "CIA students staging in France, Italy, or Japan may need both a passport AND a visa. Getting the passport in 5 days is great — but if the visa takes 3 weeks and your stage starts in 3 weeks, you are cutting it too close.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a CIA externship, academic conference, or family trip. Complete your secure order in minutes from your home or campus." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist with instructions for the nearest acceptance facility — Hyde Park Post Office, Poughkeepsie Main, or wherever is most convenient." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. CIA students can ship from the campus mail center. Most Hyde Park clients ship from home or the local post office." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 85 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives within your chosen timeframe. Whether you're staging at a Michelin kitchen in Lyon or presenting at a history conference in London — your passport is ready." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Hyde Park?", a: "We offer Hyde Park-area clients — including CIA students and FDR historians — expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors." },
    { q: "I am a CIA student — can you help with externship passports?", a: "Absolutely. Culinary Institute of America students heading to international stages are one of our most important client groups. We know the 3–6 week acceptance-to-departure window and can expedite first-time and renewal passports to meet externship start dates across Europe and Asia." },
    { q: "Where can I get passport acceptance in Hyde Park?", a: "The Hyde Park Post Office (424 Albany Post Road) is the primary facility. Poughkeepsie Main Post Office (55 Mansion Street) has more appointment slots. Rhinebeck, Wappingers Falls, and the Dutchess County Clerk are also nearby alternatives." },
    { q: "Does the FDR Presidential Library help with historian travel documents?", a: "The FDR Presidential Library provides research support for scholars but does not handle expedited passport processing. Our service bridges the gap — we expedite passports for historians, researchers, and National Park Service staff heading to international conferences and archives." },
    { q: "What about passport photos — where can I get them near Hyde Park?", a: "CVS Pharmacy and Walgreens in Hyde Park and Poughkeepsie offer passport photos. The Poughkeepsie Main Post Office has on-site photo services. All photos must be 2x2 inches, white background, no glasses. We verify photo compliance before submission." },
    { q: "Can you help with kitchen-damaged passports?", a: "Yes — grease-stained, water-damaged, and food-splattered passports are common among CIA students working in teaching kitchens. A passport with any stains, water marks, or food residue is invalid and must be replaced. We expedite damaged passport replacements." },
    { q: "I need a visa for my CIA externship in France — how does that work?", a: "Many CIA international stages require visas (France, Italy, Japan, Singapore). Once you receive your expedited passport, you apply for the visa separately. Plan for 2–4 additional weeks for visa processing. We can advise on timing based on your destination country." },
    { q: "How much does an expedited passport cost in Hyde Park?", a: "Government fees are $130 + $60 expedite fee. Our courier service fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% less than FedEx, Staples, and other third-party resellers." },
    { q: "Does Fast Passport Center have a Hyde Park office?", a: "We operate as a remote courier service — no physical office in Hyde Park, but our overnight shipping network serves Dutchess County efficiently. You can complete everything from your home, the CIA campus mail center, or any local shipping location." },
    { q: "What airports do Hyde Park travelers use?", a: "SWF (Stewart International, ~30 miles) is closest. ALB (Albany, ~70 miles) and JFK (~90 miles) are the primary international gateways. We coordinate passport timelines around your departure airport and flight date." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Hyde Park Residents",
    intro: "Hyde Park is unlike any other Hudson Valley town — it is home to the world's premier culinary college AND a presidential library in a village of 21,000 people. The combination creates passport timing challenges that span global kitchens and global history.",
    cards: [
      {
        icon: "ri-restaurant-line",
        title: "The Culinary Institute of America — The Global Kitchen Pipeline",
        subtitle: "World's premier culinary college — 3,000+ students, externships across 6 continents",
        description: "The CIA sends hundreds of students to international externships each year — staging at Michelin-starred restaurants in Lyon, Paris, Tokyo, Barcelona, Copenhagen, and beyond. Students apply for competitive externships and receive acceptances with 3–6 weeks before departure. This compressed timeline — combined with the fact that most CIA students are first-time passport applicants — creates a concentrated passport urgency cycle that peaks at the end of each semester.",
        tip: "CIA students should start their passport application when they submit their externship application — not after acceptance. The 3–6 week post-acceptance window leaves almost no room if any documentation issues arise.",
      },
      {
        icon: "ri-building-2-line",
        title: "FDR Presidential Library & Museum — International History Hub",
        subtitle: "First presidential library in the U.S. — global research destination",
        description: "The Franklin D. Roosevelt Presidential Library and Museum is not just a Hyde Park landmark — it is an active international research institution. Historians, political scientists, and diplomatic scholars from around the world visit Hyde Park to study the Roosevelt era. In turn, Hyde Park's FDR historians travel internationally for conferences at Oxford, the Sorbonne, the Roosevelt Institute in the Netherlands, and diplomatic history symposia worldwide. Conference invitations often arrive with 2–4 weeks notice.",
        tip: "FDR Library historians and researchers traveling internationally should maintain passports with at least 12 months of validity. Academic conference invitations often arrive on short notice — the passport must be ready before the invitation, not after.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF, ALB & JFK — Tri-Airport Hudson Valley Access",
        subtitle: "Stewart International (~30 miles), Albany (~70 miles), JFK (~90 miles)",
        description: "Hyde Park travelers have three airport options, each with different passport implications. Stewart International (SWF) offers Dublin direct and domestic connections. Albany International (ALB) connects to East Coast hubs. JFK is the global gateway — but 90 miles away. The airport decision affects your passport timeline: if you are flying SWF-to-Dublin, you need your passport at SWF check-in. If you are connecting through JFK, your passport must be valid before you leave Hyde Park.",
        tip: "SWF's Aer Lingus Dublin flight is popular for Hyde Park travelers heading to Europe. But if your final destination requires a connection from Dublin, your passport must be valid for the entire journey — not just the SWF departure leg.",
      },
      {
        icon: "ri-landscape-line",
        title: "Hudson River Estate Tourism & Seasonal Demand",
        subtitle: "Vanderbilt Mansion, Mills Mansion, Staatsburgh State Historic Site",
        description: "Hyde Park anchors the historic Hudson River estate corridor, drawing visitors from around the world to the Gilded Age mansions, formal gardens, and riverfront landscapes. The National Park Service manages multiple sites in Hyde Park, employing rangers and interpreters who participate in international heritage exchange programs. Summer estate tourism season (May–October) coincides with peak passport demand — both for inbound visitors and for Hyde Park residents traveling abroad during the warm months.",
        tip: "Summer is the busiest season at Hyde Park-area acceptance facilities. National Park Service staff and estate tourism professionals planning international exchanges should renew passports by April to avoid the summer crush.",
      },
    ],
    callout: {
      icon: "ri-goblet-line",
      title: "The CIA Externship Crunch — Hyde Park's Most Unique Passport Urgency",
      description: "No other small town in America generates as much culinary travel urgency as Hyde Park. When 300+ CIA students receive international externship acceptances in a two-week window at the end of each semester, the demand for expedited passport processing spikes dramatically. Our 2–9 day courier channel exists precisely for this uniquely Hyde Park phenomenon.",
    },
  },
  destinations: {
    title: "Where Hyde Park Travelers Go — And Why Passports Get Urgent",
    intro: "Hyde Park's culinary and historical DNA creates a distinctive international travel profile. Here's what drives passport urgency from the Roosevelt-Vanderbilt National Historic Site.",
    stats: [
      { stat: "44%", label: "of Hyde Park expedited requests are CIA student or culinary professional-related" },
      { stat: "3–6 Weeks", label: "post-acceptance window CIA students have to secure passport and visa before externship start" },
      { stat: "Apr–Jun & Nov–Jan", label: "dual peak seasons — end-of-semester externship placements and summer research travel" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a CIA student departing to Lyon, France" },
    ],
    destinations: [
      { name: "France", context: "CIA externships in Lyon and Paris (Michelin-starred kitchens), FDR diplomatic history research, culinary tourism", urgency: "French long-stay visa requires passport validity 3+ months beyond stage end date", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "CIA stages in Tuscany and Piedmont, FDR WWII history research, CIA culinary heritage tours", urgency: "Fall externship placements announced mid-summer — 4–6 week passport window", icon: "ri-map-pin-2-line" },
      { name: "Spain & Portugal", context: "CIA Barcelona and San Sebastián stages (molecular gastronomy), Basque culinary research", urgency: "Spring semester externships lock in November — departure is January", icon: "ri-map-pin-2-line" },
      { name: "Japan", context: "CIA Tokyo and Kyoto stages (kaiseki, sushi mastery), FDR Pacific War history research", urgency: "Japanese Certificate of Eligibility adds 4–6 weeks after passport arrival", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "SWF Dublin direct flight, FDR Churchill-era research at Oxford and Cambridge, CIA London stages", urgency: "SWF Dublin route — travelers book Aer Lingus fare sales 4–6 weeks before travel", icon: "ri-map-pin-2-line" },
      { name: "Scandinavia", context: "CIA Copenhagen stages (Noma-inspired new Nordic cuisine), FDR Nordic diplomacy research", urgency: "Noma and Geranium externship acceptances are among the most competitive — 2–3 week notice", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
      { name: "Rhinebeck", route: "/cities/rhinebeck" },
      { name: "Kingston", route: "/cities/kingston" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Hyde Park", address: "4250 Albany Post Road, Hyde Park, NY 12538", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Hyde Park", address: "4250 Albany Post Road, Hyde Park, NY 12538", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Poughkeepsie", address: "252 Main Street, Poughkeepsie, NY 12601", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Poughkeepsie Plaza", address: "2600 South Road, Poughkeepsie, NY 12601", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Poughkeepsie Main Post Office Photo", address: "55 Mansion Street, Poughkeepsie, NY 12601", hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "Walmart Photo Center — Fishkill", address: "56 West Merritt Boulevard, Fishkill, NY 12524", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "Walgreens — Rhinebeck", address: "6700 Route 9, Rhinebeck, NY 12572", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Rite Aid — Hyde Park", address: "4250 Albany Post Road, Hyde Park, NY 12538", hours: "Daily 8 AM – 9 PM", website: "https://www.riteaid.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Poughkeepsie",
      address: "13 Corporate Park Drive, Poughkeepsie, NY 12601",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Wappingers Falls",
      address: "29 Marshall Road, Wappingers Falls, NY 12590",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Wappingers Falls DMV office serving south Dutchess County residents. Appointment recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "New York Stewart International Airport",
      distance: "About 30 miles from Hyde Park",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley's primary airport with direct flights to Dublin, Orlando, and major U.S. hubs. Most convenient for Hyde Park and Dutchess County travelers.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "Stewart Airport Website",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 70 miles from Hyde Park",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with domestic and international connections. Alternative for northern Dutchess County travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Online, mail, or in-person options available for Dutchess County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS DOH Vital Records. Required for estate and legal matters in Dutchess County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Dutchess County Clerk at 22 Market Street. Certified copies available for name changes and legal purposes.",
      url: "https://www.dutchessny.gov/Departments/County-Clerk/County-Clerk.htm",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Dutchess County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/9jd/dutchess/",
    },
  ],
};

export default hydeParkConfig;